import { $, addAction, doAction } from '@situation/setdesign.util';

/* global moment */
class CalendarState {
    constructor() {
        this.format = 'MM-YYYY';
        this.activate = $.address.parameter('month');
        addAction('calendar/viewRender', this.update, 10, this);
    }

    update(view, $container) {
        if (this.activate) {
            doAction('calendar/gotoMonth', moment(this.activate, this.format));
            this.activate = false;
            return;
        }

        const selectedMonth = view.intervalStart.format(this.format);
        const startMonth = $container
            .parents('.fc')
            .fullCalendar('option', 'validRange')()
            .start.format(this.format);
        const value = selectedMonth === startMonth ? null : selectedMonth;
        $.address.parameter('month', value);
    }
}

export default CalendarState;
